"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var errors_1=require("../../errors"),IntEncoder=function(){function r(){}return r.encode=function(r,e){var n;if("string"==typeof r&&(r=parseInt(r,10)),(n=r.toString(2)).length>e||r<0)throw new errors_1.EncodingError(r+" too large to encode into "+e);return n.length<e&&(n="0".repeat(e-n.length)+n),n},r.decode=function(r,e){if(e!==r.length)throw new errors_1.DecodingError("invalid bit length");return parseInt(r,2)},r}();exports.IntEncoder=IntEncoder;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@iabtcf/core/lib/encoder/field/IntEncoder.js
// module id = 4
// module chunks = 0